import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';

export function RecommendedActions({ actions = [] }) {
  return (
    <Card className="bg-card border-border/80" data-testid="recommended-actions-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <RefreshCw className="w-4 h-4 text-[hsl(264,92%,70%)]" />
          <CardTitle className="text-base font-semibold">Recommended Actions</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground -mt-1 mb-2">
          Suggested steps to mitigate risk based on breached metrics and SOP guidance.
        </p>
        {actions.length === 0 && <p className="text-sm text-muted-foreground">No actions required</p>}
        {actions.map((action, i) => (
          <div key={i} className="flex items-start gap-2.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-[hsl(264,92%,70%)] flex-shrink-0 mt-1" />
            <div>
              <p className="text-sm">{action.action}</p>
              {action.metric && <p className="text-xs text-muted-foreground mt-0.5">{action.metric}</p>}
            </div>
          </div>
        ))}
        {actions.length > 0 && (
          <p className="text-xs text-muted-foreground mt-3">Higher scores indicate increased risk</p>
        )}
        <Link to="/metrics" className="text-xs text-[hsl(188,100%,55%)] hover:underline inline-block">
          Recommendations
        </Link>
      </CardContent>
    </Card>
  );
}
